import styled from 'styled-components';
import { themeGet } from '@packages/ui';

interface TabProps {
  selected?: boolean;
}

export const Tab = styled.div<TabProps>`
  background-color: ${(props: TabProps) => (props.selected ? themeGet.colors('potPourri') : themeGet.colors('white'))};
  border: ${themeGet.colors('potPourri')} 1px solid;
  border-bottom-width: 0;
  border-radius: 6px 6px 0px 0px;
  font-size: ${themeGet.fontSize(6)};
  padding: ${themeGet.space(2)};

  & > a {
    color: ${themeGet.colors('kilamanjaro')};

    &:hover {
      color: ${(props: TabProps) => (props.selected ? themeGet.colors('kilamanjaro') : themeGet.colors('primary'))};
    }
  }
`;
